// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__4oDXS","loading-content":"style_loading-content__VXWzP"};